import { Injectable } from '@angular/core';
import { environment } from '~environments/environment';
import { CrudService } from '~services/crud.service';
import { BehaviorSubject } from 'rxjs';
import {
  BrokerTrailerType,
  ContractDeductionType,
  Subcarrier,
  SubcarrierVendorContracts,
} from '~models/subcarrier.model';
import { HttpClient } from '@angular/common/http';

export interface SubcarrierContractsUpdate {
  subcarrierId: number;
  mainContractId?: number;
  trailerTypeContracts: SubcarrierTrailerTypeContractUpdate[];
}

export interface SubcarrierTrailerTypeContractUpdate {
  contractId: number;
  trailerTypeId: number;
}

export interface SubcarrierDeductionTypeUpdate {
  contractDeductionTypeId: number;
  contractDeductionTypeValue: number;
  deductionType: string;
}

@Injectable({
  providedIn: 'root',
})
export class SubcarrierService {
  get route(): string {
    return environment.api + '/subcarriers';
  }

  private subcarrierVendorContracts$$ = new BehaviorSubject<SubcarrierVendorContracts[]>(null);
  public subcarrierVendorContracts$ = this.subcarrierVendorContracts$$.asObservable();

  private subcarriersForLMO$$ = new BehaviorSubject<Subcarrier[]>(null);
  public subcarriersForLMO$ = this.subcarriersForLMO$$.asObservable();

  private brokerTrailerTypes$$ = new BehaviorSubject<BrokerTrailerType[]>(null);
  public brokerTrailerTypes$ = this.brokerTrailerTypes$$.asObservable();

  private contractDeductionTypes$$ = new BehaviorSubject<ContractDeductionType[]>(null);
  public contractDeductionTypes$ = this.contractDeductionTypes$$.asObservable();

  constructor(private http: HttpClient) {
    this.getBrokerTrailerTypes();
    this.getContractDeductionTypes();
  }

  public getSubcarriersForLMO() {
    this.http.get<Subcarrier[]>(this.route + '/lmo').subscribe((subcarriers: Subcarrier[]) => {
      this.subcarriersForLMO$$.next(subcarriers);
    });
  }

  public getSubcarrierVendorContracts() {
    this.http
      .get<SubcarrierVendorContracts[]>(this.route + '/vendor_contracts')
      .subscribe((subcarrierVendorContracts: SubcarrierVendorContracts[]) => {
        this.subcarrierVendorContracts$$.next(subcarrierVendorContracts);
      });
  }

  public async updateSubcarrierVendorContracts(update: SubcarrierContractsUpdate): Promise<boolean> {
    try {
      await this.http.post(this.route + '/vendor_contracts', update).toPromise();
      this.getSubcarrierVendorContracts();
      return true;
    } catch (e) {
      return false;
    }
  }

  public getBrokerTrailerTypes() {
    this.http
      .get<BrokerTrailerType[]>(this.route + '/brokerage_trailer_type')
      .subscribe((brokerTrailerTypes: BrokerTrailerType[]) => {
        brokerTrailerTypes = brokerTrailerTypes.filter((type) => type.trailerTypeName !== 'None');
        this.brokerTrailerTypes$$.next(brokerTrailerTypes);
      });
  }

  public getContractDeductionTypes() {
    this.http
      .get<ContractDeductionType[]>(this.route + '/contract_deduction_type')
      .subscribe((contractDeductionTypes: ContractDeductionType[]) => {
        this.contractDeductionTypes$$.next(contractDeductionTypes);
      });
  }
}
